export const TITLE = 'Forms';
export const UPLOAD_PREVIEW_ENDPOINT = 'upload/preview?'

export default class Application {
    constructor(json) {
        json = json || {};
        this.id = json.id || '';
        this.name = json.name || 'gappt';
        this.url = json.client_url || '';
        this.icon = json.icon_url || '';
    }

    /**
     * Getter
     * @returns {string}
     */
    get icon_letters() {
        return this.name
            .split(' ')
            .slice(0, 2)
            .reduce(
                (result, word) => {
                    result.push(word.substr(0, 1).toUpperCase());
                    return result;
                },
                []
            )
            .join('');
    }
}